<template>
	<!-- Title -->
	<div
		class="spoiler-title row row-cols-2 m-0 p-0 g-2 align-items-center justify-content-start"
		:class="{'mt-2': showBody, 'my-2': !showBody, 'sticky-top': stickyTitle}"
		@click="showBody = !showBody"
	>
		<div class="col-auto m-1 ms-2 p-0 align-items-center">
			<!-- style="height: 1em; width: 1em;" -->
			<svg
				xmlns="http://www.w3.org/2000/svg"
				:width="edgeSizePx"
				:height="edgeSizePx"
				fill="currentColor"
				class="bi bi-caret-down"
				viewBox="0 0 16 16"
			>
				<Transition name="title">
					<path v-if="showBody"
						stroke="currentColor"
						stroke-width="0.7"
						fill-rule="evenodd"
						d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
					/>
					<path v-else
						stroke="currentColor"
						stroke-width="0.7"
						fill-rule="evenodd" 
						d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
					/>
				</Transition>
			</svg>
		</div>

		<div class="col-10 col-xl m-1 p-0 pe-3 align-items-center">
			<slot name="title" class=""></slot>
		</div>
	</div>

	<!-- Body -->
	<Transition name="body">
		<div v-show="showBody" class="spoiler-body row row-cols-1 m-0 p-0 g-2 mt-1 mb-3 p-1 py-2">
			<!-- Tile payload -->
			<slot name="body" class=""></slot>
		</div>
	</Transition>
</template>




<script>
export default {
	props: {
		size: {
			type: String, // s, m, l
			required: false,
			default: 'm'
		},

		show: {
			type: Boolean,
			required: false,
			default: false,
		},

		stickyTitle: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	emits: {
		'update:show': value => typeof value === "boolean", // Validation
	},

	data() {
		return {
			showBody: this.show,
		}
	},

	watch: {
		show(newShow) {
			this.showBody = newShow
		},

		showBody(newShowBody) {
			this.$emit('update:show', newShowBody)
		},
	},

	created() {},

	mounted() {},

	methods: {},

	computed: {
		edgeSizePx() {
			switch(this.size) {
				case 's':
					return 12
				case 'm':
					return 16
				case 'l':
					return 24
				default:
					return 16
			}
		}
	},
}
</script>




<style scoped>
/* Style for title */
.spoiler-title {
	width: 100%; /* Need for corect borders in MainMenu */
	cursor: pointer;
	border-radius: 4px;
	transition: 0.3s;
	background-color: rgb(248, 249, 250)
}

.spoiler-title:hover {
	/* --bs-table-color-state: --bs-table-hover-color;
	--bs-table-bg-state: --bs-table-hover-bg; */
	background-color: rgb(233, 236, 239);
}

/* Transition for title */
.title-enter-active,
.title-leave-active {
  transition: all 0.5s ease;
}
.title-enter-from,
.title-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

/* Style for body */
.spoiler-body {
	width: 100%; /* Need for corect borders in MainMenu */
	border-radius: 4px;
	background-color: rgb(250, 251, 252)
}

/* Transition for body */
.body-enter-active,
.body-leave-active {
  transition: max-height 0.9s ease, opacity 0.9s ease, transform 0.9s ease;
}

.body-enter-from,
.body-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-20px);
}

.body-enter-to {
  max-height: 2048px;
  opacity: 1;
  transform: translateY(0);
}

.body-leave-from {
  max-height: 2048px;
  opacity: 1;
  transform: translateY(0);
}
</style>